<template>
  <Sidebar :visible="showSidebar" header="Right Sidebar" position="right"
    @update:visible="$emit('update:showSidebar', false)" class="plans-sidebar">
    <PlanAppliance v-if="appliance" :appliance="appliance" />
    <div class="p-d-flex p-flex-column p-jc-start p-ai-start p-mt-4 p-mb-4" style="gap: 50px;">
      <PlanCard v-for="card in cards" :key="card.name" :mode="card.mode" :details="card" 
        @click:activate="handleActivate(card)"
        @click:select="handleSelect(card)"
        @click:discover="handleDiscover(card)"
        @click:contract="handleContract(card)"
        :plansMapping="plansMapping"
        />
    </div>

    <!-- <PlanActivatePlusPremium  :visible="dialog.activatePlusPremium" 
      @update:visible="dialog.activatePlusPremium = $event"
      :plans="plans"  
      :appliance="appliance"
      :plansMapping="plansMapping"
      @click:activate="handleActivate($event)" /> -->

    <PlanPaymentRedirect
      :visible="dialog.paymentRedirect"
      @update:visible="dialog.paymentRedirect = $event"
      :appliance="appliance"
      :selectedPlan="selectedPlan"
    />

  </Sidebar>
</template>

<script>
import PlanAppliance from './PlanAppliance.vue';
import PlanCard from './PlanCard.vue';
// import PlanActivatePlusPremium from './PlanActivatePlusPremium.vue';
import PlanPaymentRedirect from './PlanPaymentRedirect.vue';

export default {
  emits: ['update:showSidebar'],
  components: {
    PlanAppliance,
    PlanCard,
    // PlanActivatePlusPremium,
    PlanPaymentRedirect
  },
  setup() {
  },
  props: {
    appliance: Object,
    showSidebar: Boolean,
    plans: Array,
    plansMapping: Object
  },
  data() {
    return {
      cards: [],
      dialog: {
        activatePlusPremium: false,
        paymentRedirect: false
      },
      selectedPlan: null
    };
  },
  computed: {
    hasPlusActivable() {
      return this.appliance?.plans?.some(plan => plan.code === 'PLUS' && !plan.startDate) && !this.hasPremiumActive;
    },
    hasPremiumActivable() {
      return this.appliance?.plans?.some(plan => plan.code === 'PREMIUM' && !plan.startDate) && !this.hasPlusActive;
    },
    hasGelateriaActivable() {
      return this.appliance?.plans?.some(plan => plan.code === 'GELATERIA' && !plan.startDate);
    },
    hasPlusActive() {
      return this.appliance?.plans?.some(plan => plan.code === 'PLUS' && plan.startDate);
    }, 
    getAppliancePlusPlan() {
      return this.appliance?.plans?.find(plan => plan.code === 'PLUS');
    }, 
    hasPremiumActive() {
      return this.appliance?.plans?.some(plan => plan.code === 'PREMIUM' && plan.startDate);
    },
    getAppliancePremiumPlan() {
      return this.appliance?.plans?.find(plan => plan.code === 'PREMIUM');
    },
    hasGelateriaActive() {
      return this.appliance?.plans?.some(plan => plan.code === 'GELATERIA' && plan.startDate);
    },
    getApplianceGelateriaPlan() {
      return this.appliance?.plans?.find(plan => plan.code === 'GELATERIA');
    },
    getPlusPlan() {
      return this.plans.find(plan => plan.code === 'PLUS');
    },
    getPremiumPlan() {
      return this.plans.find(plan => plan.code === 'PREMIUM');
    },
    getGelateriaPlan() {
      return this.plans.find(plan => plan.code === 'GELATERIA');
    },  
  },
  watch: {
    'appliance': 'loadCards',
    'plans': 'loadCards',
    '$i18n.locale': 'loadCards'
  },
  mounted() {
    this.loadCards();
  },
  methods: {
    getPlanByCode(code) {
      return this.plans.find(plan => plan.code === code);
    },
    loadCards() {
      this.cards = [];

      if(this.hasPremiumActivable) {
        this.cards.push({
          class: null,
          mode: 'activable',
          badges: [
            {class: 'premium', image: 'premium.svg', name: this.$t('plans.activable.premium.badge_premium')},
          ],
          image: null,
          name: null,
          title: this.$t('plans.activable.premium.description'),
          subtitle: this.$t('plans.activable.premium.title'),
          features: [
            { name: this.$t('plans.activable.premium.feature1'), image: 'premium_feature2.svg' },
            { name: this.$t('plans.activable.premium.feature2'), image: 'plus_feature2.svg' },
            { name: this.$t('plans.activable.premium.feature3'), image: 'plus_feature1.svg' },
            { name: this.$t('plans.activable.premium.feature4'), image: 'plus_feature3.svg' },
          ],
          expiration: this.calculateExpirationDate(this.appliance.reportDate, this.getAppliancePremiumPlan.lifeTimeDays),
          price: this.$t('plans.activable.premium.price', { price: this.$n(this.getPremiumPlan?.priceCentsEur / 100, 'money'), currency: '€'}),
          disclaimer: this.$t('plans.activable.premium.disclaimer'),
          events: {
            contract: null,
            activate: "PREMIUM",
            select: null,
            discover: null
          }
        });
      }

      if(this.hasPlusActivable) {
        this.cards.push({
          class: null,
          mode: 'activable',
          badges: [
            {class: 'plus', image: 'plus.svg', name: this.$t('plans.activable.plus.badge_plus')}
          ],
          image: null,
          name: null,
          title: this.$t('plans.activable.plus.description'),
          subtitle: this.$t('plans.activable.plus.title'),
          features: [
            { name: this.$t('plans.activable.plus.feature1'), image: 'plus_feature2.svg' },
            { name: this.$t('plans.activable.plus.feature2'), image: 'plus_feature1.svg' },
            { name: this.$t('plans.activable.plus.feature3'), image: 'plus_feature3.svg' },
          ],
          expiration: this.calculateExpirationDate(this.appliance.reportDate, this.getAppliancePlusPlan.lifeTimeDays),
          price: this.$t('plans.activable.plus.price', { price: this.$n(this.getPlusPlan?.priceCentsEur / 100, 'money'), currency: '€'}),
          disclaimer: this.$t('plans.activable.plus.disclaimer'),
          events: {
            contract: null,
            activate: "PLUS",
            select: null,
            discover: null
          }
        });
      }

      if(this.hasGelateriaActivable) {
        this.cards.push({
          class: null,
          mode: 'activable',
          badges: [
            {class: 'gelateria', image: 'gelateria.svg', name: this.$t('plans.activable.gelateria.badge_gelateria')},
          ],
          image: null,
          name: null,
          title: this.$t('plans.activable.gelateria.description'),
          subtitle: this.$t('plans.activable.gelateria.title'),
          features: [
            { name: this.$t('plans.activable.gelateria.feature1'), image: 'gelateria_feature1.svg' },
            { name: this.$t('plans.activable.gelateria.feature2'), image: 'gelateria_feature2.svg' },
            { name: this.$t('plans.activable.gelateria.feature3'), image: 'gelateria_feature3.svg' },
          ],
          expiration: this.calculateExpirationDate(this.appliance.reportDate, this.getApplianceGelateriaPlan.lifeTimeDays),
          price: this.$t('plans.activable.gelateria.price', { price: this.$n(this.getGelateriaPlan?.priceCentsEur, 'money') / 100, currency: '€'}),
          disclaimer: null,
          events: {
            contract: null,
            activate: "GELATERIA",
            select: null,
            discover: "gelateria"
          }
        });
      }

      if(this.hasPlusActive) {
        this.cards.push({
          class: 'plus',
          mode: 'active',
          badges: [],
          image: 'plus.svg',
          name: this.$t('plans.compare.plus_premium.plus.name'),
          title: null,
          subtitle: null,
          features: [
            { name: this.$t('plans.activable.plus.feature1'), image: 'plus_feature1.svg' },
            { name: this.$t('plans.activable.plus.feature2'), image: 'plus_feature2.svg' },
            { name: this.$t('plans.activable.plus.feature3'), image: 'plus_feature3.svg' },
          ],
          expiration: this.$d(this.getAppliancePlusPlan.endDate),
          price: null,
          disclaimer: null,
          events: {
            contract: "PLUS",
            activate: null,
            select: null,
            discover: null
          }
        });
      }

      if(this.hasPremiumActive) {
        this.cards.push({
          class: 'premium',
          mode: 'active',
          badges: [],
          image: 'premium.svg',
          name: this.$t('plans.compare.plus_premium.premium.name'),
          title: null,
          subtitle: null,
          features: [
            { name: this.$t('plans.activable.premium.feature1'), image: 'premium_feature2.svg' },
            { name: this.$t('plans.activable.premium.feature2'), image: 'plus_feature1.svg' },
            { name: this.$t('plans.activable.premium.feature3'), image: 'plus_feature2.svg' },
            { name: this.$t('plans.activable.premium.feature4'), image: 'plus_feature3.svg' },
          ],
          expiration: this.$d(this.getAppliancePremiumPlan.endDate),
          price: null,
          disclaimer: null,
          events: {
            contract: "PREMIUM",
            activate: null,
            select: null,
            discover: null
          }
        });
      }

      if(this.hasGelateriaActive) {
        this.cards.push({
          class: 'gelateria',
          mode: 'active',
          badges: [],
          image: 'gelateria.svg',
          name: this.$t('plans.overview.gelateria.badge_gelateria'),
          title: null,
          subtitle: null,
          features: [
            { name: this.$t('plans.overview.gelateria.feature1'), image: 'gelateria_feature1.svg' },
            { name: this.$t('plans.overview.gelateria.feature2'), image: 'gelateria_feature2.svg' },
            { name: this.$t('plans.overview.gelateria.feature3'), image: 'gelateria_feature3.svg' },
          ],
          expiration: this.$d(this.getApplianceGelateriaPlan.endDate),
          price: null,
          disclaimer: null,
          events: {
            contract: "GELATERIA",
            activate: null,
            select: null,
            discover: null
          }
        });
      }
    },
    handleActivate(card) {
      let plan = this.getPlanByCode(card.events.activate);
      if (plan) {
        this.selectedPlan = plan;
        this.dialog.paymentRedirect = true;
      } else {
        console.error('Plan not found for code', card.events.activate);
      }
    },
    handleSelect(card) {
      if(card.events.select === 'plus_premium') {
        this.dialog.activatePlusPremium = true;
      } else {
        console.log('Select clicked for', card);
      }
    },
    handleDiscover(card) {
      this.$window.open(this.plansMapping[this.$i18n.locale=='en-US'? 'us' : this.$i18n.locale][card.events.discover].info, '_blank');
    },
    handleContract(card) {
      console.log('Contract clicked for', card);
    },
    calculateExpirationDate(startDate, durationDays) {
      //calcola usando moment.js
      const start = this.$moment(startDate);
      const expiration = start.add(durationDays, 'days');
      return this.$d(expiration.toDate());
    }
  }

}
</script>

<style scoped>




</style>